import { render, staticRenderFns } from "./RequestPanel.vue?vue&type=template&id=9b40821c&scoped=true"
import script from "./RequestPanel.vue?vue&type=script&lang=ts"
export * from "./RequestPanel.vue?vue&type=script&lang=ts"
import style0 from "./RequestPanel.vue?vue&type=style&index=0&id=9b40821c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b40821c",
  null
  
)

export default component.exports